import { getCiamSessionToken } from './useCiamAuthorize'
import { useStore } from './useStore'

export const useCiamChangePassword = () => {
  const { state } = useStore()

  const handleChangePassword = async (payload = {}) => {
    if (typeof window === 'undefined') {
      return { ok: false, message: '' }
    }

    const sessionToken = getCiamSessionToken() ?? ''
    const userId = state?.ciamUserId ?? ''

    try {
      const response = await fetch(
        `${process.env.GATSBY_API_URL}/ciam/user/${userId}/password`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionToken}`,
          },
          body: JSON.stringify(payload),
        }
      )

      if (response.ok) {
        return { ok: true }
      }

      let message = ''
      try {
        const body = await response.json()
        if (body && typeof body.message === 'string') {
          message = body.message
        }
      } catch {
        // non-JSON error body
      }

      return { ok: false, message }
    } catch (err) {
      console.error('Error calling CIAM PUT /ciam/user/password:', err)
      return { ok: false, message: '' }
    }
  }

  return { handleChangePassword }
}
